<template>
  <div >
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="orderCode" label="订单编号：">
        <el-input v-model="dataForm.orderCode" size="mini" clearable type="text"
                  placeholder="订单编号"></el-input>
      </el-form-item>
      <el-form-item prop="receiverName" label="收货方：">
        <el-input v-model="dataForm.receiverName" size="mini" clearable type="text"
                  placeholder="收货方"></el-input>
      </el-form-item>
      <el-form-item prop="status" label="发货状态：" v-if="showStatusQuery">
        <el-select v-model="dataForm.status" size="mini">
          <el-option :value="20" label="已发货"></el-option>
          <el-option :value="30" label="已收货"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="productCode" label="品番号：" v-if="optType===20">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品番号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：" v-if="optType===20">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="SKU"
        ></el-input>
      </el-form-item>
      <el-form-item prop="nameZh" label="中文品名：" v-if="optType===20">
        <el-input
            v-model="dataForm.nameZh"
            size="mini"
            clearable
            type="text"
            placeholder="中文品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" :label="optType===10?'物料名称':'品名'" >
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            :placeholder="optType===10?'物料名称':'品名'"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽：" v-if="optType===10">
        <el-input
            v-model="dataForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="幅宽"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：" v-if="optType===10">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="克重"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar" style="margin-bottom: 0;">
      <div class="bar-item" v-if="showSelectionBtn">
        <el-button @click="$emit('selected',$refs.table.dataListSelections)" size="mini" type="primary">确定选择</el-button>
      </div>
    </div>
    <SweetTable ref="table" :selection="selection" url="/erp/receive/detail/client/list" :query-form="dataForm" :height="height">
      <el-table-column
          prop="orderCode"
          label="订单编号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===20"
          prop="product.code"
          label="品番号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===20"
          prop="product.skuCode"
          label="SKU"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===20"
          prop="product.nameZh"
          label="中文品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===20"
          prop="product.skuCode"
          label="SKU"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===10"
          prop="product.attr1"
          label="幅宽"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="optType===10"
          prop="product.attr2"
          label="克重"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          label="发货数量"
          header-align="center"
          align="center"
          prop="count"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="收货方"
          header-align="center"
          align="center"
          prop="receiverName"
          width="120"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      >
      </el-table-column>
      <el-table-column
          label="发货时间"
          header-align="center"
          align="center"
          prop="createDate"
          width="160"
      >
      </el-table-column>
      <el-table-column
          label="状态"
          header-align="center"
          align="center"
          width="80"
      >
        <template #default="{row}">
          <el-tag type="primary" v-if="row.status===20">已发货</el-tag>
          <el-tag type="warning" v-else-if="row.status===30">已收货</el-tag>
        </template>
      </el-table-column>
    </SweetTable>
  </div>
</template>

<script>
//发货记录(显示我发货的记录)
import SweetTable from '@/mixins/SweetTable'
export default {
  mixins: [SweetTable],
  components: {},
  props:{
    optType:{//操作类型,10物料订单,20成品订单
      type:Number,
      default:null
    },
    status:{
      type:Number,
      default: null
    },
    showStatusQuery:{
      type:Boolean,
      default:true
    },
    selection:{
      type:Boolean,
      default:true
    },
    queryType:{
      type:String,
      default:'sender'
    },
    height:{
      type:Number,
      default: null
    },
    showSelectionBtn:{
      type:Boolean,
      default:true
    },
  },
  data () {
    return {
      dateArr: [],
      currentId: '',
      dataForm: {
        orderCode: '',
        receiverName: '',
        productCode:'',
        skuCode:'',
        nameZh:'',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        status:'',
        queryType:'',
        type:''
      },
    }
  },
  watch:{
    optType:{
      handler:function(newVal){
        this.dataForm.type=newVal
      },
      immediate:true
    },
    queryType:{
      handler:function(newVal){
        this.dataForm.queryType=newVal
      },
      immediate:true
    },
    status:{
      handler:function(newVal){
        this.dataForm.status=newVal
      },
      immediate:true
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>


